import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useVehicleOptions } from '~/contexts/VehicleOptionsContext';
import { useRequestUrl } from '~/hooks/useRequestUrl';

export const RequestRedirect: React.FC = () => {
  const location = useLocation();
  const { eim } = useVehicleOptions();
  const requestUrl = useRequestUrl();
  const navigate = useNavigate();

  // navigate to request when valid eim is typed
  useEffect(() => {
    if (eim) {
      /// remove invalid eim and invalid feature params
      const { eim: invalidEim, f: invalidFeatures, ...others } = location.state || {};
      const url = requestUrl({ ...others, eim })
      navigate(url, { replace: true });
    }
  }, [eim, navigate, location, requestUrl]);

  return null;
}
